import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'sw', name: 'Kiswahili', flag: '🇹🇿' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
];

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const [activeCode, setActiveCode] = useState((i18n.language || 'en').split('-')[0]);

  useEffect(() => {
    const handler = (lng) => setActiveCode((lng || 'en').split('-')[0]);
    i18n.on('languageChanged', handler);
    return () => { i18n.off('languageChanged', handler); };
  }, [i18n]);

  const changeLanguage = (lng) => {
    try { localStorage.setItem('i18nextLng', lng); } catch {}
    i18n.changeLanguage(lng);
    setActiveCode(lng);
  };

  const currentLang = languages.find((lang) => lang.code === activeCode) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2 text-[#94A3B8] hover:text-white hover:bg-white/5" data-testid="language-selector-button">
          <Globe className="w-4 h-4" />
          <span className="hidden md:inline">{currentLang.flag} {currentLang.name}</span>
          <span className="md:hidden">{currentLang.flag}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 bg-[#121A2F] border-[#1E293B]">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onSelect={() => changeLanguage(lang.code)}
            data-testid={`language-option-${lang.code}`}
            className="cursor-pointer text-[#94A3B8] hover:text-white focus:text-white focus:bg-white/5"
          >
            <span className="mr-2">{lang.flag}</span>
            {lang.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
